export default __webpack_public_path__ + "static/media/smarterspa-manual.b9493a7f.pdf";